import common from "./common.js";
import home from "./home.js";
import browse from "./browse.js";
import opponentRank from "./opponent-rank.js";
import startingPitchers from "./starting-pitchers.js";
import weatherReport from "./weather-report.js";
import startingLineups from "./starting-lineups.js";
import injuryImpact from "./injury-impact.js";
import standings from "./standings.js";
import props from "./props.js";
import search from "./search.js";
import trends from "./trends.js";
import paywall from "./paywall.js";
import stats from "./stats.js";
import picks from "./picks.js";
import preferences from "./preferences.js";
import leagues from "./leagues.js";
import auth from "./auth.js";
import onboarding from "./onboarding.js";
import completeProfile from "./complete-profile.js";
import workstation from "./workstation.js";
import cheatsheet from "./cheatsheet.js";

export default {
  ...common,
  ...home,
  ...browse,
  ...opponentRank,
  ...startingPitchers,
  ...weatherReport,
  ...startingLineups,
  ...injuryImpact,
  ...standings,
  ...props,
  ...picks,
  ...search,
  ...trends,
  ...paywall,
  ...stats,
  ...preferences,
  ...leagues,
  ...auth,
  ...onboarding,
  ...completeProfile,
  ...workstation,
  ...cheatsheet,
};